


import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ArticleComponent } from './article/article.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ContactComponent } from './article/contact/contact.component';
import { HomeComponent } from './home/home.component';
import { FormMitroComponent } from './form-mitro/form-mitro.component';
import { DownloadFileComponent } from './download-file/download-file.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LogaFirmComponent } from './loga-firm/loga-firm.component';






@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ArticleComponent,
    ContactComponent,
    HomeComponent,
    FormMitroComponent,
    DownloadFileComponent,
    LogaFirmComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
